import React from "react";
import "./styles.css";
import javascriptIcon from "../../assets/techStackIcons/javaScriptIcon";
import viteIcon from "../../assets/techStackIcons/viteIcon";
import reactIcon from "../../assets/techStackIcons/reactIcon";
import plaidIcon from "../../assets/techStackIcons/plaidIcon";
import firebaseIcon from "../../assets/techStackIcons/firebaseIcon";
import tailwindIcon from "../../assets/techStackIcons/tailwindIcon";
import angularIcon from "../../assets/techStackIcons/angularIcon";
import geminiIcon from "../../assets/techStackIcons/geminiIcon";

const TechTag = ({ tech }) => {
  const icons = {
    javascript: { color: "#eddb1d", svg: javascriptIcon() },
    react: { color: "#54c0d5", svg: reactIcon() },
    plaid: { color: "black", svg: plaidIcon() },
    vite: { color: "#646cff", svg: viteIcon() },
    firebase: { color: "#f5820d", svg: firebaseIcon() },
    tailwind: { color: "#06b6d4", svg: tailwindIcon() },
    angular: { color: "#dd0031", svg: angularIcon() },
    gemini: { color: "gray", svg: geminiIcon() },
  };

  const techInfo = icons[tech.toLowerCase()] || { color: "gray", svg: "" };

  return (
    <button
      className="techTag"
      style={
        ({ border: `1px solid ${techInfo.color}` },
        { boxShadow: `1px 1px 2px ${techInfo.color}, 0px 0px 4px #000 ` })
      }
      onMouseEnter={(e) => {
        e.target.style.background = techInfo.color;
        e.target.style.color = "white";

        const svg = e.target.querySelector("svg");
        if (svg) {
          svg.style.fill = "white";
        }
      }}
      onMouseLeave={(e) => {
        e.target.style.background = "none";
        e.target.style.color = "black";

        const svg = e.target.querySelector("svg");
        if (svg) {
          svg.style.fill = techInfo.color;
        }
      }}
    >
      {techInfo.svg}
      {tech}
    </button>
  );
};

export default TechTag;
